import z from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { WeekdayEnrichAdmin } from '@/features/weekday-enrich-admin'

const weekdayEnrichSearchSchema = z.object({
  page: z.number().optional().catch(1),
  pageSize: z.number().optional().catch(20),
  filter: z.string().optional().catch(''),
  status: z.array(z.string()).optional(),
})

export type WeekdayEnrichSearchParams = z.infer<typeof weekdayEnrichSearchSchema>

export const Route = createFileRoute('/_authenticated/admin/weekday-enrich')({
  validateSearch: weekdayEnrichSearchSchema,
  component: WeekdayEnrichAdmin,
})
